import { gql } from "@apollo/client"

export const UPDATE_USER_DETAILS = gql`
  mutation updateUserDetails($input: UpdateUserDetailsInput!) {
    updateUserDetails(input: $input) {
      errors {
        field
        messages
      }
    }
  }
`
